// GetProductBulk returns different sections related to product on an ADP
export const ArticleDetailService_GetProductBulkLazy = () =>
  import("./service.grpc").then((m) => m.ArticleDetailService_GetProductBulk);
ArticleDetailService_GetProductBulkLazy.method =
  "aysa_api.services.article_detail_page.v1.ArticleDetailService/GetProductBulk" as const;

// GetRecommendations returns a streamed response of individual recommendations.
export const ArticleDetailService_GetRecommendationsLazy = () =>
  import("./service.grpc").then(
    (m) => m.ArticleDetailService_GetRecommendations
  );
ArticleDetailService_GetRecommendationsLazy.method =
  "aysa_api.services.article_detail_page.v1.ArticleDetailService/GetRecommendations" as const;

// SubscribeToSizeReminder sets the size reminder for a given sold-out size.
export const ArticleDetailService_SubscribeToSizeReminderLazy = () =>
  import("./service.grpc").then(
    (m) => m.ArticleDetailService_SubscribeToSizeReminder
  );
ArticleDetailService_SubscribeToSizeReminderLazy.method =
  "aysa_api.services.article_detail_page.v1.ArticleDetailService/SubscribeToSizeReminder" as const;

// GetProductDetailsBulk returns different sections related to product details section for desktop
export const ArticleDetailService_GetProductDetailsBulkLazy = () =>
  import("./service.grpc").then(
    (m) => m.ArticleDetailService_GetProductDetailsBulk
  );
ArticleDetailService_GetProductDetailsBulkLazy.method =
  "aysa_api.services.article_detail_page.v1.ArticleDetailService/GetProductDetailsBulk" as const;

// GetMinimalAdp returns the minimal data for the ADP
export const ArticleDetailService_GetMinimalProductBulkLazy = () =>
  import("./service.grpc").then(
    (m) => m.ArticleDetailService_GetMinimalProductBulk
  );
ArticleDetailService_GetMinimalProductBulkLazy.method =
  "aysa_api.services.article_detail_page.v1.ArticleDetailService/GetMinimalProductBulk" as const;

// Form for reporting legal concerns
// The client is expected to handle the following status codes of the response:
// - `OK` -> Success Message
// - `Not Found` or `Invalid Argument` -> Invalid/Missing Product ID
export const ArticleDetailService_ReportLegalConcernFormLazy = () =>
  import("./service.grpc").then(
    (m) => m.ArticleDetailService_ReportLegalConcernForm
  );
ArticleDetailService_ReportLegalConcernFormLazy.method =
  "aysa_api.services.article_detail_page.v1.ArticleDetailService/ReportLegalConcernForm" as const;

// InStreamSimilarProducts
export const ArticleDetailService_InStreamSimilarProductsLazy = () =>
  import("./service.grpc").then(
    (m) => m.ArticleDetailService_InStreamSimilarProducts
  );
ArticleDetailService_InStreamSimilarProductsLazy.method =
  "aysa_api.services.article_detail_page.v1.ArticleDetailService/InStreamSimilarProducts" as const;

// GetCombinedRecommendations returns combined recommendations, last seen products and AI dialogue for the product stream UI.
export const ArticleDetailService_GetCombinedRecommendationsLazy = () =>
  import("./service.grpc").then(
    (m) => m.ArticleDetailService_GetCombinedRecommendations
  );
ArticleDetailService_GetCombinedRecommendationsLazy.method =
  "aysa_api.services.article_detail_page.v1.ArticleDetailService/GetCombinedRecommendations" as const;

// GetSpecificRecommendation returns the full product list for a selected reco type .
export const ArticleDetailService_GetSpecificRecommendationLazy = () =>
  import("./service.grpc").then(
    (m) => m.ArticleDetailService_GetSpecificRecommendation
  );
ArticleDetailService_GetSpecificRecommendationLazy.method =
  "aysa_api.services.article_detail_page.v1.ArticleDetailService/GetSpecificRecommendation" as const;
